var _defs, _g, _ellipse, _ellipse2, _g2, _path, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAllocationImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MyAllocationImage",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 201.255,
    height: 152.408,
    viewBox: "0 0 201.255 152.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M5.683,19.074A5.69,5.69,0,0,1,0,13.389v-7.7a5.684,5.684,0,1,1,11.368,0v7.7A5.691,5.691,0,0,1,5.683,19.074Zm0-15.766A2.586,2.586,0,0,0,3.1,5.891v7.291a2.583,2.583,0,1,0,5.167,0V5.891A2.587,2.587,0,0,0,5.683,3.307Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M0,23.594V9.371H5.626V0H19.52V11.246H13.894V23.594Z",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.646,
    y1: 2.171,
    x2: -4.637,
    y2: 2.171,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040405"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(-5.873 55.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M51.687,402.609l-16.5,8.333h93.63l-19.836-8.333Z",
    transform: "translate(-29.311 -313.593)",
    opacity: 0.104
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    transform: "translate(17.193 11.39)",
    fill: "rgba(0,0,0,0.51)",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.152,
    height: 81.793,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 75.152,
    height: 80.793,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 74.861,
    height: 81.793,
    rx: 10,
    transform: "translate(12.03 11.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    d: "M10,0H64.861a10,10,0,0,1,10,10v7.97a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(12.03 11.39)",
    fill: "#c34141"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CalHook",
    transform: "translate(55.626 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 4.195,
    cy: 4.028,
    rx: 4.195,
    ry: 4.028,
    transform: "translate(9.324 16.967)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13",
    "data-name": "Mask Group 13",
    transform: "translate(8.153 3.418)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 4.195,
    cy: 4.028,
    rx: 4.195,
    ry: 4.028,
    transform: "translate(1.171 13.549)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M5.683,19.074A5.69,5.69,0,0,1,0,13.389v-7.7a5.684,5.684,0,1,1,11.368,0v7.7A5.691,5.691,0,0,1,5.683,19.074Zm0-15.766A2.586,2.586,0,0,0,3.1,5.891v7.291a2.583,2.583,0,1,0,5.167,0V5.891A2.587,2.587,0,0,0,5.683,3.307Z",
    transform: "translate(8.153 3.418)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CalHook-2",
    "data-name": "CalHook",
    transform: "translate(17.963 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116-2",
    "data-name": "Ellipse 116",
    cx: 4.195,
    cy: 4.028,
    rx: 4.195,
    ry: 4.028,
    transform: "translate(9.556 16.967)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13-2",
    "data-name": "Mask Group 13",
    transform: "translate(8.153 3.418)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115-2",
    "data-name": "Ellipse 115",
    cx: 4.195,
    cy: 4.028,
    rx: 4.195,
    ry: 4.028,
    transform: "translate(1.404 13.549)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14-2",
    "data-name": "Mask Group 14",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3-2",
    "data-name": "Subtraction 3",
    d: "M5.683,19.074A5.69,5.69,0,0,1,0,13.389v-7.7a5.684,5.684,0,1,1,11.368,0v7.7A5.691,5.691,0,0,1,5.683,19.074Zm0-15.766A2.586,2.586,0,0,0,3.1,5.891v7.291a2.583,2.583,0,1,0,5.167,0V5.891A2.587,2.587,0,0,0,5.683,3.307Z",
    transform: "translate(8.153 3.418)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 12.262,
    height: 11.773,
    rx: 4,
    transform: "translate(19.129 39.274)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 12.262,
    height: 12.393,
    rx: 4,
    transform: "translate(19.129 54.145)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 12.262,
    height: 11.773,
    rx: 4,
    transform: "translate(19.129 69.636)",
    fill: "#20c5a0",
    opacity: 0.597
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 12.262,
    height: 11.773,
    rx: 4,
    transform: "translate(35.908 39.274)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 12.262,
    height: 12.393,
    rx: 4,
    transform: "translate(35.908 54.145)",
    fill: "#20c5a0",
    opacity: 0.597
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 12.262,
    height: 11.773,
    rx: 4,
    transform: "translate(35.908 69.636)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 11.616,
    height: 11.773,
    rx: 4,
    transform: "translate(52.688 39.274)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 11.616,
    height: 11.773,
    rx: 4,
    transform: "translate(68.822 39.274)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 11.616,
    height: 12.393,
    rx: 4,
    transform: "translate(52.688 54.145)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 11.616,
    height: 12.393,
    rx: 4,
    transform: "translate(68.822 54.145)",
    fill: "#20c5a0",
    opacity: 0.597
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 11.616,
    height: 11.773,
    rx: 4,
    transform: "translate(52.688 69.636)",
    fill: "#20c5a0",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 11.616,
    height: 11.773,
    rx: 4,
    transform: "translate(68.822 69.636)",
    fill: "#20c5a0",
    opacity: 0.597
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(58.017)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "cakeShadow",
    cx: 54.122,
    cy: 3.698,
    rx: 54.122,
    ry: 3.698,
    transform: "translate(0 145.011)",
    opacity: 0.102
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "cakeShadow-2",
    "data-name": "cakeShadow",
    cx: 27.066,
    cy: 3.698,
    rx: 27.066,
    ry: 3.698,
    transform: "translate(82.91 145.011)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(73.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(20.828 129.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M391.292,240.009c.154,2.533.114,5.073.075,7.61h-1.086q-.181-2.353-.364-4.71a18.53,18.53,0,0,1-.793,3.246,2.827,2.827,0,0,1-.631,1.155,3.068,3.068,0,0,1-2,.618q-3.458.22-6.922.3a31.312,31.312,0,0,0,6.137-9.886c.544-1.4,1.84-2.638,3.525-2.149C390.824,236.659,391.207,238.6,391.292,240.009Z",
    transform: "translate(-379.576 -229.052)",
    fill: "#141f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M389.941,236.129a.5.5,0,0,1-.459.459l-1.516.121a.4.4,0,0,1-.5-.245.389.389,0,0,1-.021-.11,76.877,76.877,0,0,1-1.728-8.182c.126.506,4.059-.221,4.654,1.524a6.8,6.8,0,0,1-.081,2.814Q390.091,234.318,389.941,236.129Z",
    transform: "translate(-380.26 -228.171)",
    fill: "#f0918c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M385.913,244.281a4.051,4.051,0,0,1-3.072.4l-.053-.022a31.822,31.822,0,0,0,3.282-6.273,3.828,3.828,0,0,1,1.5-1.886,1.376,1.376,0,0,1,.808.022c.342.126.663.427,1.016.336l.209.251a8.7,8.7,0,0,1-.4,4.19A6.458,6.458,0,0,1,385.913,244.281Z",
    transform: "translate(-359.106 -99.937)",
    fill: "#f0918c"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(41.086 129.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M414.088,240.009c.154,2.533.114,5.073.075,7.61h-1.086q-.177-2.353-.363-4.71a18.532,18.532,0,0,1-.794,3.246,2.827,2.827,0,0,1-.631,1.155,3.068,3.068,0,0,1-2,.618q-3.458.22-6.922.3a31.313,31.313,0,0,0,6.137-9.886c.544-1.4,1.839-2.638,3.524-2.149C413.619,236.659,414,238.6,414.088,240.009Z",
    transform: "translate(-402.372 -229.052)",
    fill: "#141f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M412.74,236.129a.5.5,0,0,1-.459.459l-1.516.121a.4.4,0,0,1-.5-.245.39.39,0,0,1-.021-.11,76.877,76.877,0,0,1-1.728-8.182c.126.506,4.058-.221,4.654,1.524a6.8,6.8,0,0,1-.081,2.814Q412.887,234.318,412.74,236.129Z",
    transform: "translate(-403.056 -228.171)",
    fill: "#f0918c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M390.784,102.514a7.16,7.16,0,0,1-.138,2.63c-.372,1.339-1.343,2.721-.763,3.984a3.638,3.638,0,0,0,.914,1.1,4.587,4.587,0,0,0,1.844,1.21,2.923,2.923,0,0,0,2.844-1.047,5.887,5.887,0,0,0,1.19-2.917,3.089,3.089,0,0,0,.019-1.2c-.275-1.183-1.6-1.728-2.5-2.539-1.164-1.044-1.583-3.869-2.816-4.553C389.378,98.078,390.7,101.67,390.784,102.514Z",
    transform: "translate(-359.876 -84.631)",
    fill: "#141f45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M398.6,173.174a123.384,123.384,0,0,0-3.5,23.3c-.324,7.136-1.917,17.9-2.358,25.029h-8.043c-.613-17.1-1.226-37.932-1.84-55.028-.107-2.969,2.595-7.043,4.295-9.479.9-1.293-.526-1.367.8-2.222a52.885,52.885,0,0,1,6.645-3.649,4.938,4.938,0,0,1,2.656-.632,4.7,4.7,0,0,1,2.374,1.337,25.326,25.326,0,0,1,8.328,19.121Z",
    transform: "translate(-359.113 -90.367)",
    fill: "#ee6b09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M414.682,177.033c-.97,13.641-1.456,31.054-1.457,44.729l-7.793-.246c-1.787-14.584-4.793-32.756-8.975-46.843-1.346-4.532-3.853-19.86-1.547-23.3.746-1.113,1.085-2.335,2.4-2.582,3.981,0,4.245.63,7.624,2.591,2.247,1.3,4.7,2.61,6.373,4.656C415.775,161.5,415.145,170.529,414.682,177.033Z",
    transform: "translate(-360.351 -90.177)",
    fill: "#f58605"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M414.682,177.033c-.97,13.641-1.456,31.054-1.457,44.729l-7.793-.246c-1.787-14.584-4.793-32.756-8.975-46.843-1.346-4.532-3.853-19.86-1.547-23.3.746-1.113,1.085-2.335,2.4-2.582,3.981,0,4.245.63,7.624,2.591,2.247,1.3,4.7,2.61,6.373,4.656C415.775,161.5,415.145,170.529,414.682,177.033Z",
    transform: "translate(-360.351 -90.177)",
    fill: "#f58605"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M393.678,148.469c2.5-.28,9.187,2.686,14.849,5.493A12.357,12.357,0,0,1,410.7,156c2.635,3.223,3.5,7.686,3.665,12.139a16.05,16.05,0,0,1-15.352-6.106s-2.173-3.154-3.967-2.878-2.1,4.719-5.141,5.053h0a8.86,8.86,0,0,0-.9-.563C387.445,160.876,389.608,148.925,393.678,148.469Z",
    transform: "translate(-359.741 -90.14)",
    fill: "#040405",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M373.479,124.684a.772.772,0,0,1-.412.35c-.276.062-.519-.178-.7-.394l-6.658-7.961a2.57,2.57,0,0,1-3.315,2.446l5.825,13.709a5.266,5.266,0,0,0,.842,1.5c1.3,1.449,3.632,1.037,5.494.466a130.323,130.323,0,0,0,13.484-4.966,1.432,1.432,0,0,0,1.084-1.589c.2-3.751,3.3-19.124-2.029-18.251C382.821,110.7,375.671,121.623,373.479,124.684Z",
    transform: "translate(-356.835 -85.854)",
    fill: "#f58605"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M413.96,111.155c4.561,5.091,2.813,9.192-.135,15.361-3.165,6.627-3.934,15.853-3.985,16.184a2.417,2.417,0,0,0,.187,1.12l4.374,12.963a3.35,3.35,0,0,1-3.355,4.415h-.057q-1.128-.057-2.258-.08a15.635,15.635,0,0,1-15.343-15.922l0-.13.005-.178q-.225,3.656-.51,7.308a10.333,10.333,0,0,1-10.72,9.542l-.169-.007c-2.881-.117-.355-4.366-.355-4.366a38.143,38.143,0,0,0,7.014-15.718c.259-1.15-2.406-12.5-3.769-17.5-1-3.661-2.324-7.777-.4-11.047a9.585,9.585,0,0,1,5.906-3.947c2.341-.645,4.789-.833,7.132-1.471,2.708-.737,5.464-2.081,8.187-1.4Z",
    transform: "translate(-358.864 -85.424)",
    fill: "#f58605"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M398.548,107.688a37.313,37.313,0,0,1,5.815-1.546c.37.037.739.078,1.107.129l.315,3.068a206.744,206.744,0,0,0-13.63,24.233c-1.615-6.649-2.008-13.526-2.351-20.36a9.2,9.2,0,0,1,.339-3.644c.419-.157.846-.294,1.273-.411C393.756,108.514,396.2,108.325,398.548,107.688Z",
    transform: "translate(-359.881 -85.429)",
    fill: "#ffbd1d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M399.4,107.618c.16-.048.318-.1.477-.147l.1-.03.4-.128.628-.2h0a2.84,2.84,0,0,1,1.4,2.125c.672,3.747-3.976,8.063-7.554,7.758a3.1,3.1,0,0,1-1.44-.444A3.678,3.678,0,0,1,392.205,115a7.816,7.816,0,0,1,.5-5.991c2.013-.444,4.078-.667,6.07-1.209.166-.045.332-.089.5-.142Z",
    transform: "translate(-360.112 -85.537)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(28.626)"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M389.238,97.661c-.017,2.25.847,4.883,3.008,5.51.651.189,1.345.166,2.008.306a1.985,1.985,0,0,1,1.563,1.15c.326.99-.606,2.138-.121,3.061a1.937,1.937,0,0,0,1.077.8,6.625,6.625,0,0,0,2.768.428,2.118,2.118,0,0,0,1.244-.391c.865-.717.423-2.084.111-3.163-1.313-4.546,1.155-9.331.939-14.055a5.866,5.866,0,0,0-1.074-3.421,6.285,6.285,0,0,0-3.036-1.843,8.393,8.393,0,0,0-5.791-.145,4.711,4.711,0,0,0-2.815,4.663C389.2,92.95,389.255,95.258,389.238,97.661Z",
    transform: "translate(-388.436 -83.126)",
    fill: "#f0918c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M394.256,104.115c-.663-.139-1.357-.116-2.008-.3-2.161-.627-3.021-3.26-3.008-5.51.018-2.4-.038-4.71-.118-7.1v-.019l.166.024a.686.686,0,0,1,.667.7c.1,1.351-.02,2.725.089,4.088q.089,1.132.25,2.257a9.617,9.617,0,0,0,.582,2.383,3.927,3.927,0,0,0,1.528,1.875,9.688,9.688,0,0,0,2.018.727,2.848,2.848,0,0,1,1.712,1.212,2.787,2.787,0,0,1-.167,2.436,3.732,3.732,0,0,1-.405.687c.053-.75.5-1.568.259-2.3A1.988,1.988,0,0,0,394.256,104.115Z",
    transform: "translate(-388.437 -83.764)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M400.1,101.424a24.417,24.417,0,0,1-.329-2.714,11.732,11.732,0,0,1,.988-3.855,3.04,3.04,0,0,0,.26-1.632,1.1,1.1,0,0,0-1.185-.927c-.457.1-.727.563-.913.993a10.276,10.276,0,0,0-.719,2.5.9.9,0,0,1-.219.564c-.234.21-.6.11-.889-.016a9.51,9.51,0,0,1-5.531-7.6c-2.454,1.773-2.454,4.324-2.428,6.776a21.453,21.453,0,0,1-.787-6,7.229,7.229,0,0,1,2.495-5.332c1.84-1.422,4.381-1.5,6.694-1.233,2.908.336,6.028,1.3,7.611,3.763,1.979,3.077.8,7.109,1.138,10.753a4.332,4.332,0,0,0,.379,1.565,9.2,9.2,0,0,0,1.609,1.853,4.194,4.194,0,0,1,1.186,2.8,2.616,2.616,0,0,1-1.616,2.437,10.271,10.271,0,0,0-1.385.381c-1.021.525-1.131,1.97-1.941,2.785a5.477,5.477,0,0,1-2.4,1.05,34.925,34.925,0,0,1-3.943,1.39c-.791.143-3.288.041-3.441-1.151-.106-.818,1.066-1.094,1.647-1.41A7.751,7.751,0,0,0,400.1,101.424Z",
    transform: "translate(-388.352 -82.834)",
    fill: "#141f45"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M427.139,134.109a2.706,2.706,0,0,1-.178,1.113,2.382,2.382,0,0,1-1.163,1.033,13.584,13.584,0,0,1-3.976,1.087,145.166,145.166,0,0,1-18.786,1.8,3.757,3.757,0,0,0-.87-3.708q6.526-1.752,12.934-3.91c.431-.145,3.3-.376,3.4-.819a25.584,25.584,0,0,0-.755-3.548c-1.529-3.294-7.841-1.21-9.964-4.157-2.9-4.031-2.453-15.012,4.627-13.305,5.875,1.417,10.414,8.32,12.575,13.522A27.621,27.621,0,0,1,427.139,134.109Z",
    transform: "translate(-361.263 -85.804)",
    fill: "#f58605"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M410.333,108.33l-2.044,14.514-6.655-2.3,4.061,5.285s-7.731,7.486-12.086,8.22c0,0,7.878-2.251,13.309-7.682l-2.642-3.817,5.089,2.251,2.887-15.218Z",
    transform: "translate(-360.311 -85.673)",
    fill: "#040405",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M361.426,119.043a11.333,11.333,0,0,1-5.254-5.1.594.594,0,0,1,.058-.512.4.4,0,0,1,.552-.1l.008.005a2.59,2.59,0,0,1,.743.851c.228.306.606.582.963.45l-1.26-1.664a1.7,1.7,0,0,1-.465-1.038.641.641,0,0,1,.369-.583c.489-.207.934.363,1.265.788a3.652,3.652,0,0,0,1.409,1.095l-2.119-2.8a1.214,1.214,0,0,1-.251-.849.739.739,0,0,1,1.034-.6c.978.289,1.61,1.936,2.43,2.83a.168.168,0,0,0,.236,0,.166.166,0,0,0,.03-.195l-1-1.767a.624.624,0,0,1,1.072-.64l.011.017a20.925,20.925,0,0,1,1.295,2.686,1.858,1.858,0,0,0,1.353,1.313,3.644,3.644,0,0,0,1.722-.593c.567-.241,1.412-.178,1.571.415.319,1.191-1.625,1.183-2.112,1.815-.434.563-.118,1.108-.009,1.728C365.46,118.775,363.286,119.725,361.426,119.043Z",
    transform: "translate(-356.139 -85.737)",
    fill: "#f0918c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M362.787,117.787a.089.089,0,0,1-.089-.083,6.02,6.02,0,0,1,.075-1.83,3.152,3.152,0,0,1,.461-1.2,1.689,1.689,0,0,1,1.066-.734.093.093,0,1,1,.032.184,1.5,1.5,0,0,0-.948.656,2.959,2.959,0,0,0-.432,1.133,5.817,5.817,0,0,0-.072,1.777.094.094,0,0,1-.083.1Z",
    transform: "translate(-356.865 -86.297)",
    fill: "#c95d74"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M358.636,115.68a.093.093,0,0,1-.065-.161,10.311,10.311,0,0,1,3.207-2.072.1.1,0,1,1,.07.178,10.125,10.125,0,0,0-3.149,2.034A.089.089,0,0,1,358.636,115.68Z",
    transform: "translate(-356.406 -86.242)",
    fill: "#c95d74"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M408.71,244.281a4.052,4.052,0,0,1-3.072.4l-.053-.022a31.82,31.82,0,0,0,3.282-6.273,3.826,3.826,0,0,1,1.5-1.886,1.375,1.375,0,0,1,.808.022c.342.126.663.427,1.016.336l.209.251a8.7,8.7,0,0,1-.4,4.19A6.456,6.456,0,0,1,408.71,244.281Z",
    transform: "translate(-361.644 -99.937)",
    fill: "#f0918c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M368.221,132.41c.113.267.227.533.361.788a3.51,3.51,0,0,0,.481.711c1.3,1.449,3.632,1.037,5.494.466q5.065-1.554,9.994-3.518l.036.153c3.692-3.9,2.89,2.729,3.793,2.7,2.2-.06,1.741-.86,2.222,1.291,20.155,9.548,10.631,23.645,13.137,34.8.669,2.978,1.792,28.42,3.28,47.124l2.69.089c0-13.676.488-31.088,1.457-44.729.031-.438.063-.889.094-1.348.046-.69.089-1.4.129-2.127q.019-.364.035-.731c.043-.978.068-1.985.065-3,0-.253,0-.507-.008-.762q-.015-.762-.054-1.527c-.041-.763-.1-1.525-.193-2.279a3.384,3.384,0,0,0,1.155-1.634,3.306,3.306,0,0,0-.017-2.093L408,143.825a4.811,4.811,0,0,1-.162-.554,2.019,2.019,0,0,1-.039-.283v-.141a1.268,1.268,0,0,1,.014-.142c0-.031.016-.141.035-.321v-.017c.005-.048.011-.1.017-.156l.013-.122c.007-.067.015-.137.023-.213s.02-.178.032-.273c.009-.08.02-.164.03-.252v-.036c.012-.1.024-.193.036-.3.028-.22.059-.457.089-.711q.039-.285.084-.6c.02-.139.041-.281.063-.426s.045-.293.069-.444.049-.307.075-.467q.02-.119.04-.24.563-.055,1.124-.115,2.247-.239,4.487-.547.56-.077,1.119-.158,1.118-.163,2.234-.343c.5-.08.994-.164,1.488-.267a10.188,10.188,0,0,0,2.488-.818,4.023,4.023,0,0,0,.517-.3,2.208,2.208,0,0,0,.437-.4,1.546,1.546,0,0,0,.209-.331,1.584,1.584,0,0,0,.094-.267c.013-.052.025-.1.034-.157a3.537,3.537,0,0,0,.048-.548v-.142a27.619,27.619,0,0,0-2.152-10.9,33.959,33.959,0,0,0-3.181-5.9q-.267-.393-.547-.779-.14-.193-.283-.384-.287-.381-.587-.753c-.4-.495-.816-.978-1.244-1.431a18.248,18.248,0,0,0-2.782-2.43h0c-.1-.068-.2-.132-.294-.2q-.408-.267-.829-.508c-.089-.049-.172-.1-.259-.144-.136-.073-.273-.144-.411-.211l-.568-.336-5.88-3.477c-2.723-.679-3.422,1.025-6.132,1.761-.377.1.146,1.724-.236,1.808-.543,4.7-5.451,12.437-6.684,13.853-3.346,3.842-4.309,2.37-6.625,3.91l-1.105-9.413s.666,8.206-5.721,11.178c-1.113.518-2.033.926-2.8,1.244a10.954,10.954,0,0,0-1.647.022c-2.642.3-5.154-1.559-6.445-3.881s-1.63-5.041-1.941-7.681a2.047,2.047,0,0,0-.666-.326,2.2,2.2,0,0,1-1.168-.023l-.1.023.03.071h0l2.88,6.78Zm41.748-1.03c.248-.832.523-1.664.826-2.48.076-.2.155-.407.234-.609.239-.6.495-1.2.769-1.77q.232-.485.453-.954c.076.049.148.1.22.157l.036.028c.067.053.132.108.195.168l.006.005,0,0c.036.034.069.069.1.1l.036.036.007.008c.031.035.061.072.089.108.013.016.028.031.041.048h0q.043.056.083.115l.026.036h0a1.657,1.657,0,0,1,.089.148l.012.019h0c.042.072.081.146.117.224,0,.007.007.016.011.028v.007a.188.188,0,0,0,.013.04v.008c0,.014.01.031.014.048v.01l.019.064v.016c.007.024.013.05.02.076.017.061.035.131.053.205.011.044.022.089.034.137l.01.04.027.107.012.051.027.113.012.047c.073.3.15.644.221.978l.012.054c.028.136.057.267.084.4l.01.049c.026.128.05.25.071.363l.007.041c.011.056.02.11.029.161.006.036.012.069.017.1l0,.032a.474.474,0,0,0,.01.062c0,.02,0,.022,0,.033l.007.051v.03a.133.133,0,0,0,0,.043c0,.013,0,.019,0,.027v.1a.172.172,0,0,1,0,.03.116.116,0,0,1-.016.037l-.007.011a.165.165,0,0,1-.022.027l-.01.011a.406.406,0,0,1-.043.035.811.811,0,0,1-.133.074l-.084.035c-.035.013-.072.026-.11.039l-.038.012-.089.026-.046.013-.093.025-.043.012-.141.033h-.006l-.149.032-.051.01-.111.022-.056.011-.116.021-.051.009-.166.028-.148.024-.294.046-.145.021-.161.024-.1.014-.094.013-.111.016-.056.008-.141.021-.218.034-.178.031-.066.013h-.017l-.041.01h-.015l-.043.012a7.063,7.063,0,0,1-.668.245Z",
    transform: "translate(-356.837 -85.429)",
    fill: "#f0918c",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M400.736,142.6l11.962-.458c-.231,1.365-.384,2.524-.481,3.334-3.345-1.471-7.864-1.333-9.705-1.2a16.44,16.44,0,0,0-1.777-1.679Z",
    transform: "translate(-361.104 -89.437)",
    fill: "#040405",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M395.534,111.109c-.106-.818,1.066-1.094,1.647-1.41a7.75,7.75,0,0,0,3.722-7.747,24.429,24.429,0,0,1-.329-2.715,11.731,11.731,0,0,1,.988-3.855,3.048,3.048,0,0,0,.26-1.632,1.1,1.1,0,0,0-1.185-.927c-.457.1-.727.563-.913.993a10.275,10.275,0,0,0-.719,2.5.908.908,0,0,1-.219.564c-.234.21-.6.11-.889-.016-.062-.027-.123-.056-.185-.089-.084-.882-.551-1.709-.627-2.6a4.965,4.965,0,0,1,.812-3.222,9.942,9.942,0,0,1,3.691-2.808,3.032,3.032,0,0,1,2.464-.506,2.626,2.626,0,0,1,1.307,2.176c.478,3.155-.645,6.5.417,9.509.432,1.225,1.2,2.305,1.666,3.519a8.059,8.059,0,0,1,.418,3.985,2.424,2.424,0,0,0-.6.2c-1.021.526-1.131,1.97-1.941,2.785a5.485,5.485,0,0,1-2.4,1.05,34.755,34.755,0,0,1-3.943,1.39C398.185,112.4,395.688,112.3,395.534,111.109Z",
    transform: "translate(-360.524 -83.361)",
    fill: "#040405",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M412.577,134.192l.016,0a10.877,10.877,0,0,0,1.1-.36l1.155-.383c.431-.145,3.3-.377,3.4-.819a25.589,25.589,0,0,0-.754-3.548,2.855,2.855,0,0,0-1.084-1.223c.034-.6.238-1.09,1.044-1.077,1.01.017,1.473,1.023,1.792,1.831l1.415,3.591a2.341,2.341,0,0,1,.212,1.677c-.3.758-1.249.978-2.056,1.086-5.454.747-13.07,2.006-18.523,2.755-.7-1.035-.39-1.422.555-1.412A45.09,45.09,0,0,0,412.577,134.192Z",
    transform: "translate(-361.013 -87.727)",
    fill: "#f58605"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M395.216,136.1a1.775,1.775,0,0,0-.994.155.614.614,0,0,0-.252.831c.006.012.013.024.02.036l1.777.4a.586.586,0,0,1,.421.235.394.394,0,0,1-.187.49,1.085,1.085,0,0,1-.562.1,2.423,2.423,0,0,1-2.146-.856c-.186-.31-.236-.684-.4-1.01a.8.8,0,0,0-.857-.511c-.4.123-.487.658-.41,1.066a2.97,2.97,0,0,0,.828,1.558,2.045,2.045,0,0,0-.11,1.532,3.328,3.328,0,0,0,1.03,2.062,2.98,2.98,0,0,0,1.265.491,8.247,8.247,0,0,0,4.13-.277c2.168-.723,1.708-2.408.889-4.088C398.831,136.585,396.982,136.165,395.216,136.1Z",
    transform: "translate(-360.087 -88.749)",
    fill: "#f0918c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(40.753 11.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(12.647)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M335.578,105.259a25.758,25.758,0,0,0-.489,3.575,16.709,16.709,0,0,1-1.127,3.867.944.944,0,0,0,.546,1.22l.019.007,1.051.378a3.642,3.642,0,0,0,.889,3.21c1.341,1.341,4.579.8,6.622,2.844S345.2,123.2,345.2,123.2l10.641-3.6s-4.513-2.306-5.9-5.37.365-7-.073-9.7S338.716,95.118,335.578,105.259Z",
    transform: "translate(-333.9 -96.334)",
    fill: "#f1a8ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M340.689,119.23a4.618,4.618,0,0,0-1.561-.484c-1.328-.283-2.77-1.066-2.962-2.41a12.479,12.479,0,0,0-.084-1.65c-.134-.47-.484-.85-.653-1.308a3.625,3.625,0,0,1,.028-1.948c.336-1.688.711-3.372,1-5.065a10.246,10.246,0,0,0,.205-3.17,10.5,10.5,0,0,0-1.079,2.442,25.73,25.73,0,0,0-.489,3.575,16.7,16.7,0,0,1-1.127,3.867.944.944,0,0,0,.546,1.22l.019.007,1.051.378a3.642,3.642,0,0,0,.889,3.21c.929.929,2.766.956,4.488,1.563A1.467,1.467,0,0,0,340.689,119.23Z",
    transform: "translate(-333.9 -96.708)",
    fill: "#fff",
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M340.356,108.369a2.164,2.164,0,0,1,1.753-2.151,1.607,1.607,0,0,1,1.487.467c1.354,1.354.072,3.679-1.093,4.047a5.846,5.846,0,0,1-1.656.355s.533,2.958,2.75,3.326,6.249-.936,6.249-.936.444-5.81,1.488-7.956-1.042-5.949-4.661-7.236-9.611-.444-11.559-2.391c0,0-1.932,5.332-.4,6.869a5.763,5.763,0,0,0,3.555,1.594s-1.042,1.962.307,3.311,1.1,2.391,1.1,2.391a1.429,1.429,0,0,0,.674-1.226Z",
    transform: "translate(-333.924 -95.895)",
    fill: "#040405"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0 130.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M335.731,246.2s-2.2,5.886-3.492,5.886-13.014-3.653-12.558-7.611,6.608.851,9.812.851A25.648,25.648,0,0,1,335.731,246.2Z",
    transform: "translate(-319.668 -242.91)",
    fill: "#604f50"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M372.835,186.714l10.849,17.067a5.365,5.365,0,0,0,7.008,1.879L417.4,191.506s-3.324.228-3.037-5.065c0,0-17,3.652-22.376,6.924-6.234-7.2-2.749-21.041-8.628-23.8Z",
    transform: "translate(-325.588 -104.097)",
    fill: "#613211"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M341.129,125.857l-5.687,5.879,12.624,20.334,3.377,17.151S379.2,164.5,379.2,164.113c0-.245-3.5-17.76-6.054-30.5a16.247,16.247,0,0,0-15.93-13.055h-1.333Z",
    transform: "translate(-321.425 -98.64)",
    fill: "#254593"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M340.768,125.949s16.864,3.466,23.224,2.795,0-8.384,0-8.384,2.023-3.565-3.855-4.144-14.937,6.746-17.346,6.746S339.043,125.608,340.768,125.949Z",
    transform: "translate(-321.931 -98.154)",
    fill: "#254593"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M350.71,124.876a15.031,15.031,0,0,1-2.745-.231.186.186,0,1,1,.068-.365h0c6.043,1.134,15.225-2.364,15.318-2.4a.185.185,0,0,1,.247.089.186.186,0,0,1-.089.247l-.025.01a48.882,48.882,0,0,1-5.421,1.646A32.658,32.658,0,0,1,350.71,124.876Z",
    transform: "translate(-322.802 -98.786)",
    fill: "#11162d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M361.673,130.661c-5.033,0-11.933-1.9-12.343-2.015a.186.186,0,0,1,.1-.355,71.539,71.539,0,0,0,7.419,1.576c5.02.762,8.237.5,9.3-.754a4.1,4.1,0,0,0,.009-5.7.186.186,0,1,1,.267-.26,4.533,4.533,0,0,1,.009,6.2C365.612,130.318,363.811,130.661,361.673,130.661Z",
    transform: "translate(-322.958 -98.923)",
    fill: "#11162d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M335.381,132.746s-1.488,2.4.658,7.214,17.59,10.433,17.59,10.433l-9.375,13.467s-.444,2.146,3.253,2.812c0,0,12.8-11.839,15.242-17.462S343.01,121.61,335.381,132.746Z",
    transform: "translate(-321.362 -99.652)",
    fill: "#254593"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M353.686,153.12a4.05,4.05,0,0,0,1.132-2.735,2.756,2.756,0,0,0-1.37-1.915,9.751,9.751,0,0,0-2.26-.889,32.613,32.613,0,0,1-11.048-6.043,11.308,11.308,0,0,1-3.009-3.466,4.968,4.968,0,0,1-.163-4.449c.564-1.078,2.183-2.464,2.557-3.76a6.742,6.742,0,0,0-4.146,2.912s-1.488,2.4.658,7.214c.962,2.155,4.593,4.473,8.308,6.375a17.417,17.417,0,0,1,5.681,2.257,5.926,5.926,0,0,1,.922.751c1.612.659,2.68,1.05,2.68,1.05l-8.746,12.564q-.323.7-.622,1.412a1.762,1.762,0,0,0,.063.26A137.309,137.309,0,0,0,353.686,153.12Z",
    transform: "translate(-321.362 -99.677)",
    fill: "#fff",
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M340.911,127.212l6.493,1.532s-6.009-.556-8.582.628Z",
    transform: "translate(-321.801 -99.382)",
    fill: "#141f45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M352.958,163.475a.186.186,0,0,1-.186-.187.182.182,0,0,1,.055-.131c3.582-3.555,9.831-10.077,11.436-13.774,1.458-3.359-6.487-12.975-14.172-17.151a.186.186,0,0,1,.178-.326c7.981,4.336,15.886,14.054,14.336,17.624s-7.117,9.52-11.515,13.888A.188.188,0,0,1,352.958,163.475Z",
    transform: "translate(-323.045 -99.902)",
    fill: "#11162d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M350.74,158.712a.187.187,0,0,1-.186-.187.189.189,0,0,1,.034-.1l4.043-5.817-8.066-3.466a.186.186,0,0,1,.145-.342h0l8.484,3.644-4.307,6.188A.188.188,0,0,1,350.74,158.712Z",
    transform: "translate(-322.65 -101.783)",
    fill: "#11162d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M350.751,174.679l-10.027,30.689-11.473,31.709s3.83,3.715,7.262,2.657c0,0,12.717-19.413,14.237-31.094l10.867-13.106a23.526,23.526,0,0,1,7.267-5.9c4.672-2.422,11.96-8.2,9.619-20.064Z",
    transform: "translate(-320.735 -104.098)",
    fill: "#7e4014"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M419.032,188.676s2.267-2.577,4.223-1.846,7.1,5.871,9.3,8.072-3.183,3.3-5.629.856a6.445,6.445,0,0,0-5.065-2.086S418.233,193.576,419.032,188.676Z",
    transform: "translate(-330.719 -106.005)",
    fill: "#604f50"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M423.283,186.693s-.853.053-.523.616c.387.66,5.3,4.693,6.849,6.245s3.1,3.231,3.867,2.466-1.632-3.816-3.182-5.367S425.309,186.562,423.283,186.693Z",
    transform: "translate(-331.138 -106.003)",
    fill: "#917777"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M344.819,168.152s-2.2,2.812-4.834,2.812c0,0-.347,1.414,1.325,1.414l.873-.218a1.035,1.035,0,0,0,.978.873c.836,0,.978-.254.978-.254s-.1.473.674.473a1.58,1.58,0,0,0,1.1-.327s-.031.327.514.327,1.788-2.425,1.788-2.425l-3.4-2.673",
    transform: "translate(-321.927 -103.94)",
    fill: "#f1a8ba"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M417.024,185.814c1.978,1.978,5.878,1.635,6.132.267.766-.766-1.632-3.816-3.182-5.367s-4.984-4.088-7.011-3.96a.574.574,0,0,0-.111.014c-1.411-.152-2.867,1.107-3.453,1.688-1.885.412-17.152,3.815-22.185,6.882-6.234-7.2-2.749-21.041-8.627-23.8,0-.245-3.5-17.761-6.054-30.5a16.243,16.243,0,0,0-8.594-11.3c-.571-.87-1.06-1.463-1.06-1.463s2.023-3.565-3.855-4.144c-2.332-.229-5.163.785-7.882,2.092a8.049,8.049,0,0,1-1.625-2.254c-.047-.1-.089-.212-.131-.317,0-.006.444-5.81,1.488-7.955s-1.042-5.948-4.661-7.236c-2.073-.738-4.926-.777-7.351-1.042-.008.04-.015.078-.022.118-.593,3.523-1.17,7.047-1.756,10.57-.4,2.426-.7,5.232.954,7.05,1.574,1.727,4.2,1.785,6.487,2.292s4.821,2.335,4.255,4.6c-.643,2.577-4.343,2.671-6.294,4.473-2.114,1.95-1.61,5.6.241,7.8s4.633,3.339,7.249,4.532,5.325,2.646,6.72,5.16c1.7,3.06.968,7-.917,9.953s-4.745,5.113-7.544,7.213l.491.24c.278-.267.583-.563.908-.881l.288,1.465,6.642,3.244c-.167.541-.32,1.112-.464,1.739q-1.84,8.03-4.218,15.924a247.957,247.957,0,0,1-11.465,30.616q-3.731,8.257-8.062,16.227a28.045,28.045,0,0,0-2.361,5.228,16.85,16.85,0,0,0,3.4.907c.816,0,1.994-2.345,2.755-4.074a4.27,4.27,0,0,0,.457-.11s12.717-19.413,14.237-31.094l10.867-13.106a23.526,23.526,0,0,1,7.267-5.9c.23-.12.468-.248.711-.384l9.237,14.53a5.365,5.365,0,0,0,7.009,1.878l26.253-13.914A6.628,6.628,0,0,1,417.024,185.814Z",
    transform: "translate(-320.818 -96.064)",
    opacity: 0.2,
    fill: "url(#linear-gradient)",
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAllocationImage);
export default __webpack_public_path__ + "static/media/MyAllocationImage.1047430bdebe1ebf0785f314f24cc258.svg";
export { ForwardRef as ReactComponent };